import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthenticationPage } from '../components/authentication.tsx';
import { redirectSignedIn } from '../redirect-signed-in.ts';
import { Route as parent } from './root.tsx';
export const Route = createRoute({
  getParentRoute: () => parent,
  path: '/reset-password',
  beforeLoad: redirectSignedIn,
  validateSearch: z.object({ token: z.string().optional() }).parse,
  component: () => <AuthenticationPage mode="reset" />,
});
